import { Box, Button } from "@mui/material";
import { styledComponent } from "../utils/styled";
import { useTheme } from "../context/ThemeContext";

// Figma: node 13001-12293 (dark) / 13001-9315 (light) — chat option pill, no icon.
const OptionsPillButton = styledComponent(Button)(({ isDark }) => ({
  height: "30px",
  padding: "7px 12px",
  borderRadius: "6px",
  background: isDark ? "#262A2E" : "#FFFFFF",
  boxShadow: isDark
    ? "0px 4px 4px 0px rgba(0,0,0,0.25)"
    : "0px 4px 4px 0px rgba(0,0,0,0.04)",
  color: isDark ? "#ECEFF3" : "#434950",
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.03px",
  textTransform: "none",
  minWidth: 0,
  whiteSpace: "nowrap",
  transition: "none",
}));

// Generic multiple-choice buttons for an agent chat prompt (topic: OPTIONS_PROMPT).
// Purely presentational — the caller decides whether to render this at all.
export default function OptionsPromptButtons({ options, disabled, onSelect }) {
  const { isDark } = useTheme();

  if (!Array.isArray(options) || options.length === 0) return null;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px", mt: "8px" }}>
      {options.map(option => (
        <OptionsPillButton
          key={option.value}
          isDark={isDark}
          disabled={disabled}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </OptionsPillButton>
      ))}
    </Box>
  );
}
